import React from 'react';
import CalculusOfResilience from '../components/CalculusOfResilience';

function CalculusOfResiliencePage() {
  return <CalculusOfResilience />;
}

export default CalculusOfResiliencePage;
